import replaceSymbolE from './replace-symbol-e'
import { isNRGTokenAddress } from './index'

interface BasicData {
  token0?: {
    id: string
    name: string
    symbol: string
  }
  token1?: {
    id: string
    name: string
    symbol: string
  }
}

// override tokens with incorrect symbol or names
export function updateNameData(data: BasicData): BasicData | undefined {
  if (data?.token0?.id) {
    data.token0.symbol = isNRGTokenAddress(data.token0.id)
      ? 'NRG'
      : replaceSymbolE({ id: data.token0.id, symbol: data.token0.symbol })
  }

  if (data?.token1?.id) {
    data.token1.symbol = isNRGTokenAddress(data.token1.id)
      ? 'NRG'
      : replaceSymbolE({ id: data.token1.id, symbol: data.token1.symbol })
  }

  return data
}
